import React from "react";
import { Chip } from "@mui/material";

export const VerificationStatusBadge = ({ status }) => {
  switch (status) {
    // ✅ success
    case "verified":
    case "finished":
    case "submitted":
    case "manually_approved":
      return <Chip color="success" label={status} />;

    // ⚠️ warning
    case "finished_with_warnings":
    case "finished_by_overridden":
      return <Chip color="warning" label={status} />;

    // ❌ error
    case "failed":
      return <Chip color="error" label={status} />;

    // ℹ️ info
    case "skipped":
    case "no_data_available":
      return <Chip color="info" label={status} />;

    // default gray
    case "pending":
    case "started":
    case "canceled":
    case "processing":
    default:
      return <Chip color="default" label={status} />;
  }
};
